import SideBarContext from "../../contexts/side-bar-context";
import { useContext } from "react";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import ChatHistoryDrawer from "./chat-history-drawer";
import SettingsDrawer from "./settings-drawer";
import { isPegInstalled } from "../../lib/auth";

const SideBar = ({ children }) => {
  const { isSideBarOpen, setIsSideBarOpen, toggleSideBar, isMyAppsOpen, setIsMyAppsOpen, setIsSettingsOpen } = useContext(SideBarContext);
  const userCtx = useContext(UserContext);
  const businessCtx = useContext(BusinessContext);
  const business = businessCtx.activeBusiness;
  const user = userCtx.user;

  return (
    <>
      <div
        className={`absolute lg:relative transition-all transform z-[32] gap-[20px]
          ${(!user.is_pseudonymous && isSideBarOpen) ? 'max-w-[240px] lg:min-w-[250px] lg:w-[240px] w-full border-r-[1px] border-[transparent] opacity-1' :
            'max-w-[240px] lg:min-w-[0px] w-full lg:max-w-0 lg:w-0 lg:px-0 -translate-x-full lg:translate-x-0 overflow-hidden opacity-0'
          }  content-between custom-bg-white-200 duration-500 ease-in-out py-[17px] h-[100dvh] grid ignore-click`}
      >
        {children}
      </div>
      {/* <SettingsDrawer/> */}
      <div onClick={() => { setIsSideBarOpen(false); setIsMyAppsOpen(false); setIsSettingsOpen(false); }} className={`block lg:hidden w-full h-full absolute top-0 left-0 z-[31] ${(isSideBarOpen) ? 'block' : 'hidden'}`} ></div>
      <ChatHistoryDrawer />
    </>
  );
};

export default SideBar;